import {createEntityAdapter} from '@reduxjs/toolkit';
import {MonthlyRate} from 'api/rates/rates.types';

/**
 * CRUD adapter for handling Monthly Rates data within the store.  Default is sorted by the  ratig rule id (ruleId).
 *
 * @see https://redux-toolkit.js.org/api/createEntityAdapter
 */
export const monthlyRatesAdapter = createEntityAdapter<MonthlyRate>({
    selectId: (monthlyRate) => monthlyRate.ruleId,
});
